import { CHANGE_VALUES_PRESTATION_TYPE } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'

export const contractSaveParametersGeneration = ({
  contactPreferences = {},
  billingData = {},
  contractData = {},
  characteristicsData = {},
  energyConsumptionData = {},
  electricityMeterData = {},
  gasMeterData = {},
  mainAddressData = {},
  contractId,
  contactId,
  addressId,
  billingAddressId,
  residenceAddressId,
  action = 'save',
  type,
}) => {
  const options = new URLSearchParams()
  const { electricityMeter = {}, gasMeter = {} } = mainAddressData
  const isChangePrestation = CHANGE_VALUES_PRESTATION_TYPE.includes(characteristicsData.prestationType)
  const isElecOrDual = characteristicsData.energyType === 'elec' || characteristicsData.energyType === 'dual'
  const isGasOrDual = characteristicsData.energyType === 'gas' || characteristicsData.energyType === 'dual'

  options.append('action', action)
  options.append('type', type || '')
  options.append('id', contractId || '')
  options.append('contact_id', contactId || '')
  options.append('address_id', addressId || '')
  options.append('client_type', contactPreferences.clientType || '')
  options.append('prestation_type', characteristicsData.prestationType || '')
  options.append('energy_type', characteristicsData.energyType || '')

  options.append('offer_id', contractData.offerId ? parseInt(contractData.offerId) : '')
  options.append('organisation_id', contractData.providerId ? parseInt(contractData.providerId) : '')

  options.append('invoice_sending_mode', billingData.sendingMode || '')
  options.append('invoice_frequency', billingData.frequency || '-1')
  options.append('payment_mode', billingData.paymentMode || '-1')
  options.append('iban', billingData.iban || '')

  options.append('bic', billingData.bic ?? '')
  options.append('account_holder_tax_id_code', billingData.accountHolderTaxIdCode ?? '')

  options.append('owner_name_different', billingData.differentAccountHolder ? 1 : 0)
  options.append('owner_lastname', billingData.accountHolderLastname ?? '')
  options.append('owner_firstname', billingData.accountHolderFirstname ?? '')
  options.append('owner_tax_id_code', billingData.accountHolderTaxIdCode ?? '')

  options.append('billing_address_id', billingAddressId ?? '')
  options.append('residence_address_id', residenceAddressId ?? '')
  options.append('italy_doi_phone', contractData.italyDoiPhone ?? '')
  options.append('italy_doi_privacy', contractData.italyDoiPrivacy ?? '')
  // Stored in the slice as `signingMethod` (camelCase, sibling of providerId),
  // shipped to the backend as `signing_method`. Edison-workflow only on the
  // UI side, but we always append so an empty string clears it server-side.
  options.append('signing_method', contractData.signingMethod ?? '')
  options.append('monthly_amount', energyConsumptionData.monthlyAmount ?? '')

  if (isElecOrDual) {
    options.append('meter_id_elec', electricityMeter.pdlNo || '')
    options.append(
      'provider_external_id_elec',
      contractData.providerExternalId || electricityMeterData.providerExternalId || '',
    )
    options.append('monthly_amount_elec', energyConsumptionData.monthlyAmountElec ?? '')
    options.append('meter_power_elec', electricityMeterData.meterPower ?? '')
    options.append('original_meter_power_elec', electricityMeterData.originalMeterPower ?? '')
    options.append('meter_option_elec', electricityMeterData.meterOption ?? '-1')
    options.append('usage_type_elec', electricityMeterData.usage ?? '')
    options.append('voltage_elec', electricityMeterData.voltage ?? '')
    options.append('distributor_elec', electricityMeterData.distributor ?? '')
    options.append('origin_market_elec', electricityMeterData.originMarket ?? '')
    options.append('supplier_id_elec', isChangePrestation ? (electricityMeterData.energySupplier ?? '') : '')

    options.append('consumption_base', energyConsumptionData.consumptionBase ?? '')
    options.append('consumption_biorariaF1', energyConsumptionData.consumptionBiorariaF1 ?? '')
    options.append('consumption_biorariaF2', energyConsumptionData.consumptionBiorariaF2 ?? '')
    options.append('consumption_biorariaF3', energyConsumptionData.consumptionBiorariaF3 ?? '')
  }

  if (isGasOrDual) {
    options.append('meter_id_gas', gasMeter.pceNo || '')
    options.append('car_gas', energyConsumptionData.carGas ?? '')
    options.append('monthly_amount_gas', energyConsumptionData.monthlyAmountGas ?? '')

    options.append('usage_type_gas', gasMeterData.usage ?? '')
    options.append('distributor_gas', gasMeterData.distributor ?? '')
    options.append('origin_market_gas', gasMeterData.originMarket ?? '')
    options.append('supplier_id_gas', isChangePrestation ? (gasMeterData.energySupplier ?? '') : '')
    options.append('provider_external_id_gas', gasMeterData.providerExternalId ?? '')
    options.append('distributor_code_gas', gasMeterData.distributorCode ?? '')
    options.append('days_of_use_gas', gasMeterData.daysOfUse ?? '')
    options.append('meter_category_gas', gasMeterData.meterCategory ?? '')
    options.append('max_thermal_capacity_gas', gasMeterData.maxThermalCapacity ?? '')
  }

  return options
}
